import { mergeListOfUsers } from '../../components/helper/Utils';
import { mergeUnique } from '../../helpers/array/array';
import {
    FETCH_PENDING_REFERRAL_PAYMENTS_FAILED,
    FETCH_PENDING_REFERRAL_PAYMENTS_START,
    FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS,
    FETCH_REFERRAL_PAYMENTS_HISTORY_START,
    FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS,
    FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED,
    FETCH_REFERRED_USERS_START,
    FETCH_REFERRED_USERS_SUCCESS,
    FETCH_REFERRED_USERS_FAILED,
    REFERRAL_WITHDRAWAL_FAILED,
    REFERRAL_WITHDRAWAL_START,
    REFERRAL_WITHDRAWAL_SUCCESS,
} from '../actions/ActionConstant';

export const initialState = {
    pending_referrals: {
        data: [],
        loading: false,
        error: false,
        success: null,
        inputData: {},
        hasNext: true,
        page: 1,
        size: 10,
        metadata: {}
    },
    referral_payments_history: {
        data: [],
        loading: false,
        error: false,
        success: null,
        inputData: {},
        hasNext: false,
        page: 1,
        size: 10,
        metadata: {}
    },
    referred_users: {
        data: [],
        loading: false,
        error: false,
        success: null,
        inputData: {},
        hasNext: false,
        page: 1,
        size: 10,
        metadata: {},
    },
    referral_withdraw: {
        data: {},
        loading: false,
        error: false,
        success: null,
        message: '',
    },
    referral_available_balance: 0,
    referral_total_earning: 0,
    filters: {
        key: '',
        filterValues: {},
        filterCount: 0,
    },
};

const ReferralReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PENDING_REFERRAL_PAYMENTS_START:
            return {
                ...state,
                pending_referrals: {
                    ...state.pending_referrals,
                    inputData: action.data,
                    loading: true,
                    success: false,
                    error: null,
                    hasNext: action.data?.page === 1 ? true : state.pending_referrals.hasNext,
                },
            };

        case FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS: {
            const newPage = action.data?.metadata?.pagination?.page || 1;
            const currentData = state.pending_referrals.data || [];
            const fetchedRecords = action.data.records || [];
            const numberOfPages = action.data?.metadata?.pagination?.numberOfPages || 1;

            const mergedRecords = newPage === 1
                ? fetchedRecords
                : mergeUnique(currentData, fetchedRecords, 'id');

            return {
                ...state,
                pending_referrals: {
                    ...state.pending_referrals,
                    data: mergedRecords,
                    page: newPage,
                    hasNext: newPage < numberOfPages,
                    loading: false,
                    success: true,
                    error: null,
                    metadata: action.data?.metadata?.pagination || {},
                },
                referral_available_balance: action.data.available_balance ?? state.referral_available_balance,
                referral_total_earning: action.data.total_earnings ?? state.referral_total_earning,
            };
        }

        case FETCH_PENDING_REFERRAL_PAYMENTS_FAILED:
            return {
                ...state,
                pending_referrals: {
                    ...state.pending_referrals,
                    loading: false,
                    success: false,
                    error: true,
                },
            };
        // Referral Payments History Management

        case FETCH_REFERRAL_PAYMENTS_HISTORY_START:
            return {
                ...state,
                referral_payments_history: {
                    ...state.referral_payments_history,
                    data: action.data?.page === 1 ? [] : state.referral_payments_history.data,
                    loading: true,
                    error: null,
                },
            };
        case FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS: {
            const newPage = action.data?.metadata?.pagination?.page || 1;
            const currentData = state.referral_payments_history?.data || [];
            const numberOfPages = action.data?.metadata?.pagination?.numberOfPages || 1;

            const mergedRecords = newPage === 1
                ? action.data.records
                : mergeUnique(currentData, action.data.records, "id");

            return {
                ...state,
                referral_payments_history: {
                    data: mergedRecords,
                    metadata: action.data.metadata?.pagination || {},
                    loading: false,
                    error: null,
                    hasNext: newPage < numberOfPages,
                    success: true,
                    inputData: action.data?.inputData || state.referral_payments_history.inputData,
                },
            };
        }

        case FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED:
            return {
                ...state,
                referral_payments_history: {
                    ...state.referral_payments_history,
                    loading: false,
                    error: true,
                },
            };


        //  Referred users
        case FETCH_REFERRED_USERS_START:
            return {
                ...state,
                referred_users: {
                    ...state.referred_users,
                    loading: true,
                    success: false,
                    error: false,
                    inputData: action.data || {},
                },
            };

        case FETCH_REFERRED_USERS_SUCCESS: {
            const newPage = action.data?.metadata?.pagination?.page || 1;
            const currentUsers = state.referred_users?.data || [];
            const fetchedUsers = action.data?.records || [];
            const numberOfPages = action.data?.metadata?.pagination?.numberOfPages || 1;

            const mergedRecords = newPage === 1
                ? fetchedUsers
                : mergeUnique(currentUsers, fetchedUsers, 'id');

            return {
                ...state,
                referred_users: {
                    ...state.referred_users,
                    data: mergedRecords,
                    metadata: action.data?.metadata?.pagination || {},
                    loading: false,
                    success: true,
                    error: false,
                    hasNext: newPage < numberOfPages,
                },
            };
        }

        case FETCH_REFERRED_USERS_FAILED:
            return {
                ...state,
                referred_users: {
                    ...state.referred_users,
                    loading: false,
                    success: false,
                    error: true,
                },
            };
        case REFERRAL_WITHDRAWAL_START:
            return {
                ...state,
                referral_withdraw: {
                    ...state.referral_withdraw,
                    loading: true,
                    error: false,
                    success: null,
                    message: '',
                },
            };

        case REFERRAL_WITHDRAWAL_SUCCESS: {
            return {
                ...state,
                referral_withdraw: {
                    ...state.referral_withdraw,
                    data: action.data || {},
                    loading: false,
                    error: false,
                    success: true,
                    message: action.data?.message || 'Withdrawal request submitted successfully',
                },
            };
        }

        case REFERRAL_WITHDRAWAL_FAILED:
            return {
                ...state,
                referral_withdraw: {
                    ...state.referral_withdraw,
                    loading: false,
                    error: true,
                    success: false,
                    message: action.error?.message || 'Withdrawal request failed',
                },
            };
        default:
            return state;
    }
};

export default ReferralReducer;
